import * as React from "react";
import { Grid } from "@/components/ui/shadcn-compat";

const FooterCopyright = () => {
  return (
    <div className="container">
      <Grid.Row className="footer-copyright-wrapper">
        <Grid.Col width={6} className="text-left">
          Copyright © {new Date().getFullYear()}. HireXL All Rights Reserved.
        </Grid.Col>
        <Grid.Col width={6} className="text-right">
          Designed & Developed by{" "}
          <a
            target="_blank"
            href="https://technocube.co/"
          >
            Technocube(India)
          </a>
        </Grid.Col>
      </Grid.Row>
    </div>
  );
};

export default FooterCopyright;
